var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreateicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 100C77.61 100 100 77.61 100 50C100 22.39 77.61 0 50 0C22.39 0 0 22.39 0 50C0 77.61 22.39 100 50 100Z",
    fill: "#F3F6F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.0059 85.9961C30.1241 85.9961 14.0078 69.8798 14.0078 49.998C14.0078 30.1163 30.1241 14 50.0059 14C69.8876 14 86.0039 30.1163 86.0039 49.998C86.0039 69.8798 69.8876 85.9961 50.0059 85.9961ZM46.4155 64.3995L71.8661 38.9453L66.776 33.8552L46.4155 54.2193L36.2316 44.0354L31.1415 49.1255L46.4155 64.3995Z",
    fill: "#50CFBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateicon);
export default __webpack_public_path__ + "static/media/createicon.a14b9d9eff2459f55fccf5a429f0a637.svg";
export { ForwardRef as ReactComponent };